<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="notificationTemplateModal" aria-labelledby="notificationTemplateModalLabel">
    <div class="modal-dialog modal-xl">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ template.id ? 'Шаблон: ' + (template.code || '') : 'Новый шаблон' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="template.code" :required="true" id="template.code" name="template.code" placeholder="Код" type="text" mb="5" />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="template.category" class="required">Категория</label>
                <v-select
                  v-model="template.category"
                  input-id="template.category"
                  :loading="categoriesLoading"
                  :disabled="categoriesLoading"
                  :options="categorySelectOptions"
                  :reduce="(item) => item.id"
                  placeholder="Выберите категорию..."
                  class="mb-3 bg-gray-100 form rounded"
                  label="label"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="template.img" id="template.img" name="template.img" placeholder="Изображение (img)" type="text" mb="5" />
            </div>
            <div class="col-md-6">
              <input-field v-model="template.icon" id="template.icon" name="template.icon" placeholder="Иконка" type="text" mb="5" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="template.actionDeepLink" id="template.actionDeepLink" name="template.actionDeepLink" placeholder="Action DeepLink" type="text" mb="5" />
            </div>
            <div class="col-md-3">
              <div class="custom-select dynamic mb-5">
                <label for="template.actionType">Action Type</label>
                <v-select
                  v-model="template.actionType"
                  input-id="template.actionType"
                  :options="actionTypeOptions"
                  :reduce="(item) => item.code"
                  label="label"
                  :clearable="true"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="custom-select dynamic mb-5">
                <label for="template.actionDeepLinkType">Action DeepLink Type</label>
                <v-select
                  v-model="template.actionDeepLinkType"
                  input-id="template.actionDeepLinkType"
                  :options="deepLinkTypeOptions"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="template.deepLink" id="template.deepLink" name="template.deepLink" placeholder="DeepLink" type="text" mb="5" />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="template.deepLinkType">DeepLink Type</label>
                <v-select
                  v-model="template.deepLinkType"
                  input-id="template.deepLinkType"
                  :options="deepLinkTypeOptions"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Заголовок (title)</div>
            <div class="row">
              <div class="col-md-4">
                <input-field v-model="template.title['ru-RU']" id="template.title.ru" name="template.title.ru" placeholder="Русский (ru-RU)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.title['uz-UZ']" id="template.title.uz" name="template.title.uz" placeholder="Узбекский (uz-UZ)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.title['en-US']" id="template.title.en" name="template.title.en" placeholder="Английский (en-US)" type="text" mb="5" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Сообщение (message)</div>
            <div class="row">
              <div class="col-md-4">
                <input-field v-model="template.message['ru-RU']" id="template.message.ru" name="template.message.ru" placeholder="Русский (ru-RU)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.message['uz-UZ']" id="template.message.uz" name="template.message.uz" placeholder="Узбекский (uz-UZ)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.message['en-US']" id="template.message.en" name="template.message.en" placeholder="Английский (en-US)" type="text" mb="5" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Текст на кнопке (actionName)</div>
            <div class="row">
              <div class="col-md-4">
                <input-field v-model="template.actionName['ru-RU']" id="template.actionName.ru" name="template.actionName.ru" placeholder="Русский (ru-RU)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.actionName['uz-UZ']" id="template.actionName.uz" name="template.actionName.uz" placeholder="Узбекский (uz-UZ)" type="text" mb="5" />
              </div>
              <div class="col-md-4">
                <input-field v-model="template.actionName['en-US']" id="template.actionName.en" name="template.actionName.en" placeholder="Английский (en-US)" type="text" mb="5" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button type="button" @click="saveTemplate" :disabled="saving" class="btn btn-primary btn-sm">
            {{ saving ? 'Сохранение...' : (template.id ? 'Обновить' : 'Создать') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import vSelect from 'vue-select'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const createLocaleObject = () => ({
  'ru-RU': '',
  'uz-UZ': '',
  'en-US': '',
});

const createDefaultTemplate = () => ({
  id: null,
  code: '',
  category: '',
  img: '',
  icon: '',
  title: createLocaleObject(),
  message: createLocaleObject(),
  actionName: createLocaleObject(),
  actionType: null,
  actionDeepLink: '',
  actionDeepLinkType: 'internal',
  deepLink: '',
  deepLinkType: 'internal',
});

export default {
  name: 'NotificationTemplateModal',
  components: { Loader, InputField, vSelect },
  props: {
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      template: createDefaultTemplate(),
      categories: [],
      categoriesLoading: false,
      actionTypeOptions: [
        { code: null, label: 'null' },
        { code: 'button', label: 'button' },
        { code: 'anchor', label: 'anchor' },
      ],
      deepLinkTypeOptions: ['internal', 'external'],
    };
  },
  computed: {
    categorySelectOptions() {
      return this.categories.map((c) => ({
        id: c.id,
        label: this.formatCategoryLabel(c),
      }));
    },
  },
  mounted() {
    this.hydrateTemplate();
    this.fetchCategories();
    setTimeout(() => {
      const modalEl = document.getElementById('notificationTemplateModal');
      if (modalEl) {
        modalEl.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal(false);
        });
      }
    }, 10);
  },
  methods: {
    fetchCategories() {
      this.categoriesLoading = true;
      axios
        .get('/notification/api/v2/issuer/category', {
          params: { page: 0, size: 500 },
        })
        .then((res) => {
          const payload = res?.data;
          const content = Array.isArray(payload?.content) ? payload.content : [];
          this.categories = content;
          this.normalizeCategoryToId();
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
          this.categories = [];
        })
        .finally(() => {
          this.categoriesLoading = false;
        });
    },
    formatCategoryLabel(c) {
      if (!c) return '';
      const nameRu = typeof c.name === 'object' && c.name ? c.name['ru-RU'] || c.name['en-US'] || '' : '';
      const parts = [c.code, nameRu].filter(Boolean);
      return parts.length ? parts.join(' — ') : String(c.id || '');
    },
    hydrateTemplate() {
      const source = this.itemData || {};
      this.template = {
        ...createDefaultTemplate(),
        ...source,
        title: { ...createLocaleObject(), ...(source.title || {}) },
        message: { ...createLocaleObject(), ...(source.message || {}) },
        actionName: { ...createLocaleObject(), ...(source.actionName || {}) },
      };
    },
    normalizeCategoryToId() {
      const current = this.template?.category;
      if (!current || !Array.isArray(this.categories) || this.categories.length === 0) return;
      const byId = this.categories.find((c) => c && c.id === current);
      if (byId) return;
      const byCode = this.categories.find((c) => c && c.code === current);
      if (byCode?.id) {
        this.template.category = byCode.id;
      }
    },
    closeModal(isUpdate) {
      const modalInstance = bootstrap.Modal.getInstance(document.getElementById('notificationTemplateModal'));
      if (modalInstance) modalInstance.hide();
      this.$emit('closeModal', isUpdate);
    },
    saveTemplate() {
      this.saving = true;
      this.normalizeCategoryToId();
      const payload = {
        id: this.template.id || null,
        code: this.template.code || null,
        category: this.template.category || null,
        img: this.template.img || null,
        icon: this.template.icon || null,
        title: this.template.title,
        message: this.template.message,
        actionName: this.template.actionName,
        actionType: this.template.actionType || null,
        actionDeepLink: this.template.actionDeepLink || null,
        actionDeepLinkType: this.template.actionDeepLinkType || 'internal',
        deepLink: this.template.deepLink || null,
        deepLinkType: this.template.deepLinkType || 'internal',
      };

      axios.post('/notification/api/v2/issuer/template', payload)
        .then(() => {
          notify({
            duration: 7000,
            type: 'success',
            speed: 1000,
            title: 'Успешно',
            text: this.template.id ? 'Шаблон успешно обновлен!' : 'Шаблон успешно создан!',
          });
          this.closeModal(true);
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>

</style>
